import React from 'react'
import imgApple from '../../assets/images/ic_apple.png'
import imgGoogle from '../../assets/images/ic_google.png'
import { SocialProviderId } from '../firebase/firebaseClient'

export interface Props {
  disabled: boolean
  onSignIn: (providerId: SocialProviderId) => void
}

export function FirebaseSocialButtons(props: Props) {
  return (
    <>
      <div className='social-login'>
        <button type='button' className='google' onClick={() => props.onSignIn('google')} disabled={props.disabled}>
          <img src={imgGoogle} alt='Google icon' />
          <span className='button-title'>Continue with Google</span>
        </button>
      </div>
      <div className='social-login'>
        <button type='button' className='apple' onClick={() => props.onSignIn('apple')} disabled={props.disabled}>
          <img src={imgApple} alt='Apple icon' />
          <span className='button-title'>Continue with Apple</span>
        </button>
      </div>
    </>
  )
}
